<ng-container *ngIf="{ value: dateFilter$ | async } as dateFilter">
  <ng-container *ngIf="{ value: loading$ | async } as loading">

    <dynamic-list #settledList class="h-100"
                  [style.display]="dateFilter.value ? 'none' : 'block'"
                  [class.hide]="current !== 'Settled'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('settled', $event)"
    >
      <app-empty-state page="Credit Card" tab="Settled" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #settledDateFilterList class="h-100"
                  [style.display]="dateFilter.value ? 'block' : 'none'"
                  [class.hide]="current !== 'Settled'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('settled', $event, undefined, dateFilter.value, true)"
    >
      <app-empty-state filter="Range" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #pendingList class="h-100"
                  [style.display]="dateFilter.value ? 'none' : 'block'"
                  [class.hide]="current !== 'Pending'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('pending', $event)"
    >
      <app-empty-state page="Credit Card" tab="Pending" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #pendingDateFilterList class="h-100"
                  [style.display]="dateFilter.value ? 'block' : 'none'"
                  [class.hide]="current !== 'Pending'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('pending', $event, undefined, dateFilter.value, true)"
    >
      <app-empty-state filter="Range" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #preChargebacksList class="h-100"
                  [style.display]="dateFilter.value ? 'none' : 'block'"
                  [class.hide]="current !== 'Pre-chargebacks'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('pre-chargeback', $event)"
    >
      <app-empty-state page="Credit Card" tab="Pre-chargebacks" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #preChargebacksDateFilterList class="h-100"
                  [style.display]="dateFilter.value ? 'block' : 'none'"
                  [class.hide]="current !== 'Pre-chargebacks'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('pre-chargeback', $event, undefined, dateFilter.value, true)"
    >
      <app-empty-state filter="Range" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #chargebacksList class="h-100"
                  [style.display]="dateFilter.value ? 'none' : 'block'"
                  [class.hide]="current !== 'Chargebacks'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('chargeback', $event)"
    >
      <app-empty-state page="Credit Card" tab="Chargebacks" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #chargebacksDateFilterList class="h-100"
                  [style.display]="dateFilter.value ? 'block' : 'none'"
                  [class.hide]="current !== 'Chargebacks'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('chargeback', $event, undefined, dateFilter.value, true)"
    >
      <app-empty-state filter="Range" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #refundsList class="h-100"
                  [style.display]="dateFilter.value ? 'none' : 'block'"
                  [class.hide]="current !== 'Refunds'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('refund', $event)"
    >
      <app-empty-state page="Credit Card" tab="Refunds" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #refundsDateFilterList class="h-100"
                  [style.display]="dateFilter.value ? 'block' : 'none'"
                  [class.hide]="current !== 'Refunds'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('refund', $event, undefined, dateFilter.value, true)"
    >
      <app-empty-state filter="Range" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #surchargeList class="h-100"
                  [style.display]="dateFilter.value ? 'none' : 'block'"
                  [class.hide]="current !== 'Surcharge'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('surcharge', $event)"
    >
      <app-empty-state page="Credit Card" tab="Surcharge" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

    <dynamic-list #surchargeDateFilterList class="h-100"
                  [style.display]="dateFilter.value ? 'block' : 'none'"
                  [class.hide]="current !== 'Surcharge'"
                  [canLoadMoreTop]="false"
                  (loadMoreBottom)="loadItems('surcharge', $event, undefined, dateFilter.value, true)"
    >
      <app-empty-state filter="Range" [style.display]="loading.value ? 'none' : 'block'"></app-empty-state>
    </dynamic-list>

  </ng-container>
</ng-container>
